import {Selectors} from '../Settings';
import BookingDatepicker from "../Components/BookingDatepicker";

class BookingController {
	constructor() {
		if(document.querySelector(Selectors.BOOKING_DATEPICKER)) {
			new BookingDatepicker(document.querySelector(Selectors.BOOKING_DATEPICKER));
		}
	}
}

export default BookingController;